import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, HostListener, OnDestroy, forwardRef } from "@angular/core";
import { loadModules } from "esri-loader";
import { ILayer } from "../interface/layer";
import { UserService } from "../services/user.service";
import { IRegion } from "../interface/region";
import { MapToolsComponent } from "../map-tools/map-tools.component";
import { SearchToolComponent } from "../search-tool/search-tool.component";
import { AssetDetailService } from "../services/asset-detail.service";
import { IUser } from "../interface/user";
import { AuthenticationService } from "../services/authentication.service";
import Swal from "sweetalert2";
import { forkJoin } from "rxjs";
import { AssetAttributesService } from "../services/asset-attributes.service";
import { SelectToolComponent } from "../select-tool/select-tool.component";
import { QueryLayersService } from "../services/query-layers.service";
import { environment } from "src/environments/environment";
import html2canvas from "html2canvas";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { GenericLayerService } from "../services/generic-layer.service";
import { Globals } from "../shared/globals";
import { CrowdSourcedInfoComponent } from "src/app/crowd-sourced-info/crowd-sourced-info.component";

import { EventEmittersService } from "../services/event-emitters.service";
import { GenericMapMethodsService } from "../services/generic-map-methods.service";
import { DatePipe, NgIf, NgClass, NgFor } from "@angular/common";
import { faAngleDoubleLeft, faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { BASE64_PREFIX } from "../shared/utils";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { IClient } from "../interface/client";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { IdleModalComponent } from "../modals/idle-modal/idle-modal.component";
import { map } from "rxjs/operators";
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { RouteLogsComponent } from "../route-logs/route-logs.component";
import { MatIconModule } from "@angular/material/icon";
import { CrowdSourcedInfoComponent as CrowdSourcedInfoComponent_1 } from "../crowd-sourced-info/crowd-sourced-info.component";
import { CrewmanagementComponent } from "../crewmanagement/crewmanagement/crewmanagement.component";
import { FormsModule } from "@angular/forms";
import { HelpCenterComponent } from "../help-center/help-center.component";
import { AssetViewerComponent } from "../asset-viewer/asset-viewer.component";
import { QueryBuilderComponent } from "../query-builder/query-builder.component";
import { AdministratorComponent } from "../admin-mmm/admin-mmm.component";
import { RedlineComponent } from "../redline/redline.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { HeaderComponent } from "../header/header.component";
import { MakeViewerComponent } from "../make-viewer/make-viewer.component";
import { TaskTableComponent } from "../task-table/task-table.component";
import { AssetTableComponent } from "../asset-table/asset-table.component";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { CreateTaskComponent } from "../create-task/create-task.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MatRadioModule } from "@angular/material/radio";
import { ILayerSelections } from "../interface/selectedSet";

@Component({
  selector: "sms-esri-map",
  templateUrl: "./esri-map.component.html",
  styleUrls: ["./esri-map.component.scss"],
  // tslint:disable-next-line:no-host-metadata-property
  host: { class: "w-100" },
  standalone: true,
  imports: [NgIf, ConfigurableHeaderComponent, MapToolsComponent, AssetTableComponent, TaskTableComponent, MakeViewerComponent, HeaderComponent,
    SearchToolComponent, SelectToolComponent, CdkDrag, CdkDragHandle, NgClass, NgFor, MatCheckboxModule, RedlineComponent,
    forwardRef(() => AdministratorComponent),
    QueryBuilderComponent, AssetViewerComponent, HelpCenterComponent, FormsModule, CrewmanagementComponent, CrowdSourcedInfoComponent_1,
    MatIconModule, RouteLogsComponent, TranslateModule, CustomTranslatePipe, CreateTaskComponent, MatTabsModule, MatRadioModule]
})
export class EsriMapComponent implements OnInit, OnDestroy {
  isFromQB: boolean = false;
  ExportStatus: any;
  gpServiceTrackUrl: any;
  @HostListener("document:keydown.enter", ["$event"])
  onKeydownHandler(event: KeyboardEvent) {
    const target = event.target as HTMLElement;
    if (
      target &&
      target.localName === "span" &&
      target.className === "dijit dijitReset dijitInline esriButton esriButtonActive dijitActive esriButtonFocused esriButtonActiveFocused dijitActiveFocused dijitFocused"
    ) {
      (target as HTMLInputElement).click();
      let measureToolsText = (target as HTMLInputElement).querySelectorAll("span.dijitReset.dijitInline.dijitButtonText.dijitDisplayNone");
      //let toolNames = ["area", "distance", "location"];
      this.measurement.setTool(measureToolsText[0].innerHTML.toLowerCase(), true);
    }
    if (target && (target as any).type === "checkbox" && (target as any).id?.indexOf("lyr-chk-") === 0) {
      (target as HTMLInputElement).click();
    }
  }
  constructor(
    private userService: UserService,
    private assetAttributesService: AssetAttributesService,
    public assetService: AssetDetailService,
    private authenticationService: AuthenticationService,
    private queryLayersService: QueryLayersService,
    private translateService: TranslateService,
    private GenericLayerService: GenericLayerService,
    public objGlobals: Globals,
    public eeService: EventEmittersService,
    public genericMapMethodsService: GenericMapMethodsService,
    public datepipe: DatePipe,
    private idle: Idle,
    private modalService: NgbModal
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.proLicense = this.currentUser.clientType === "PROFESSIONAL" ? true : false;
    this.basemapProLicense = this.currentUser.clientType === "PREMIUM" || this.currentUser.clientType === "PROFESSIONAL" ? true : false;
    this.eeService.emitShowGrid.subscribe(() => {
      this.assetTableVisible = this.eeService.assetTableVisible;
    });
    this.eeService.emitSelectedFeaturesOnMap.subscribe((res: ILayerSelections[]) => {
      this.selectedSet = res;
    });
    this.eeService.emitShowCard.subscribe((show) => {
      this.assetViewerVisible = show;
    });
    this.eeService.emitMaintenanceView.subscribe((showTaskViewer) => {
      this.taskTableVisible = false;
      this.showSelectedTasksData = false;
      if (this.showSelect) {
        this.showSelectedTasksData = showTaskViewer;
      }
      else {
        this.taskTableVisible = showTaskViewer;
      }
    });
    this.eeService.emitMakeViewer.subscribe((showMakeViewer) => {
      this.makeViewerVisible = showMakeViewer;
    });
    //Added for Visualization layers
    //Visualization layers
    this.eeService.emitSetVisualizationAssetViewer.subscribe((data) => {
      this.visualizationLayerData = data;
    });

  }

  get mapLoaded(): boolean {
    return this.loaded;
  }

  @Output() mapLoadedEvent = new EventEmitter<boolean>();
  @Output() basemapChangeEvent = new EventEmitter<boolean>();
  @ViewChild(MapToolsComponent) mapTools!: MapToolsComponent;
  @ViewChild(SearchToolComponent)
  searchTools!: SearchToolComponent;
  @ViewChild(CrowdSourcedInfoComponent)
  crowdSource!: CrowdSourcedInfoComponent;
  @ViewChild(SelectToolComponent)
  selectTools!: SelectToolComponent;
  // The <div> where we will place the map
  @ViewChild("mapViewNode", { static: true }) private mapViewEl!: ElementRef;

  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faAngleDoubleLeft = faAngleDoubleLeft;

  public chkimage: any;
  public showLidar = false;
  public langkeyrec: string = "";
  public loading = false;
  public zoom = 6;
  public center: number[] = [-118.250437, 34.171234];
  public basemap = "streets";
  public loaded = false;
  public proLicense = true;
  public basemapProLicense = true;
  public map: any;
  region: any;
  // Injected Service
  public currentUser: IUser;
  public _userService: any;
  // class variables
  public Draw: any;
  public Measure: any;
  public Query: any;
  public FeatureLayer: any;
  public FeatureTable: any;
  public GraphicsLayer: any;
  public ArcGISDynamicMapServiceLayer: any;
  public BasemapGallery: any;
  public BasemapToggle: any;
  public LocateButton: any;
  public Extent: any;
  public OverviewMap: any;
  public SearchWidget: any;
  public InfoTemplate: any;
  public Color: any;
  public SimpleLineSymbol: any;
  public SimpleFillSymbol: any;
  public TextSymbol: any;
  public Font: any;
  public SimpleMarkerSymbol: any;
  public Graphic: any;
  public Circle: any;
  public Units: any;
  public Point: any;
  public Locator: any;
  public ColorPicker: any;
  ////public Legend: any;
  public webMercatorUtils: any;
  public PictureMarkerSymbol: any;
  public PopupTemplate: any;
  public Popup: any;
  public domConstruct: any;
  public registry: any;
  public VectorTileLayer: any;
  public ScreenPoint: any;
  public PopupExtended: any;
  public RelationshipQuery: any;
  public TemplatePicker: any;
  public Editor: any;
  public Edit: any;
  public Geoprocessor: any;
  public scaleUtils: any;
  public request: any;
  public QueryTask: any;
  public Polyline: any;
  public Polygon: any;
  public SimpleRenderer: any;
  public TimeInfo: any;
  public TimeSlider: any;
  public TimeExtent: any;
  public geometryEngine: any;
  public mathUtils: any;
  public geometryJsonUtils: any;
  // other variables
  public drawTool: any;
  public measurement: any;
  public measureGlayer: any;
  public basemapGallery: any;
  public basemapToggle: any;
  public sources: any[] = [];
  public searchWidget: any;
  public MapOnClick: any;
  public satMapId: string = "";
  public streetMapId: string = "";
  public category: any;
  // bool variables
  public showEsriWidgets = false;
  public showMeasure = false;
  public showBaseMapGallery = false;
  public showLayers = false;
  public showFilter = false;
  public streetBasemap = true; // default is street basemap
  public satelliteBasemap = false;
  public showSearch = false;
  public showSelect = false;
  public ProximityAssets = false;
  public showRedlineDraw = false;
  public layerTabActive = true;
  public showLayerList = true;
  public showFilterList = true;
  public showAdd = false;
  public closeQueryBuilderVar = false;
  public closeHelpVar = false;
  public crowdSourceVar = false;
  public closeAdministrator = false;
  public queryBuilderArray: any[] = [];
  public event: any;
  // harcoded data
  public token: string | null = null;
  public layerData: any = {
    userLayers: [] as ILayer[],
    graphicLayers: [],
    dynamicMapLayer: {}
  };
  public regionData: IRegion[] = [] as IRegion[];
  public inventoryLayersData: ILayer[] = [] as ILayer[];  // used on first tab of Layers UI
  public referenceLayersData: ILayer[] = [] as ILayer[];  // used on second tab of Layers UI
  public selectedSet: ILayerSelections[] = [];
  public assetTableVisible: boolean = false;
  public assetViewerVisible: boolean = false;
  public taskTableVisible: boolean = false;
  public makeViewerVisible: boolean = false;
  public AttributeInspector: any;
  public all: any;

  expand = this.translateService.instant("Select.carddisplay.expand");
  minimize = this.translateService.instant("Select.carddisplay.minimize");
  public mapServiceLyr: any;
  showSelectedTasksData: boolean | undefined;
  public DataEditor = false;
  admin: any;
  public idletimeout: any;
  public dataEditorSettings: any;
  taskType: any;
  public index: any;
  public layerIndex: any;
  public crewmanagement: any;
  // Added by Madhuri JIRA ID:35
  public graphicsUtils: any;
  // TSDRSAM-1099 Manikantha V
  public esriBundle: any;
  //Added for Visualization layers
  //Added by Venkatesh for Jira Id:677
  public visualizationLyrTabActive = false;
  public visualizationLayersData: any[] = [];
  public wmsLayer: any;
  public showVisualizationDetails: any;
  public visualizationLayerData: any;
  public wmsUrlHostNames: any[] = [];
  isQueryBuilderMinimized = false;
  //
  public basemapsForToggle: string[] = ["Streets", "Streets Map"];

  #region  //2/23/26  sms-create-task on esri-map, used by any component that needs it rather than duplicating
  public showCreateTask = false;
  public createTaskAsset: any;
  public editTaskAttributes: any;
  showCreateTaskForm(asset: any, taskAttributes: any = null): void {      // asset object when creating a new task, taskAttributes when editing
    this.createTaskAsset = taskAttributes ? null : asset;
    this.editTaskAttributes = taskAttributes;
    this.showCreateTask = true;
  }
  hideCreateTaskForm(): void {
    this.showCreateTask = false;
  }
  //#endregion sms-create-task

  setThis() {
    return this;
  }
  toggleMinimizeQb(minimize: boolean): void {
    this.isQueryBuilderMinimized = minimize;
  }
  ngOnInit() {
    const _this = this.setThis();

    if (this.currentUser.clientId === 1) {
      _this.basemap = "gray";
    }
    let altMapClients = [
      1    //prod MMMCity
      , 143  //prod LakeCountyIL
      //,510   //qa StLucieFL
    ]
    if (altMapClients.includes(this.currentUser.clientId)) { // This basemap is more recent than the streets version available in the basemap toggle. todo - figure out why streets selected from the Professional basemap palet is more current than the version in toggle.
      _this.basemap = "streets-navigation-vector"
    }

    this.dataEditorSettings = JSON.parse(localStorage.getItem("dataEditorSettings"));

    forkJoin([
      _this.userService.getUserLayerAccess(this.currentUser.clientId, this.currentUser.userId),   // asset class(es) (including children) assigned to user on Admin/User
      _this.userService.getUserRegionAccess(this.currentUser.clientId, this.currentUser.userId),
      _this.queryLayersService.getAllLayersInformation(environment.proxy + this.currentUser.webServiceURL)
    ]).subscribe(
      (results) => {

        const userLayerAccess: { gisLayerId: string | number; accessPrivilege: string }[] = results[0] as any[];
        _this.regionData = results[1] as IRegion[];
        const clientRESTinfo: any = results[2];

        _this.currentUser.assignedAssetClasses = [] as ILayer[];
        userLayerAccess.forEach((ul) => {
          const layerId = typeof ul.gisLayerId === "string" ? parseInt(ul.gisLayerId, 10) : ul.gisLayerId;  //ToDo someday - update API to return integers
          let layerName = clientRESTinfo.layers.find( (i: any) => i.id === layerId )?.name;
          if (!layerName) { layerName = clientRESTinfo.tables.find( (i: any) => i.id === layerId )?.name; }
          _this.currentUser.assignedAssetClasses!.push({
            layerId: layerId,
            accessPrivilege: ul.accessPrivilege,
            name: layerName
          } as ILayer);
        });



        _this.processServiceLayerInformation(_this.currentUser.assignedAssetClasses, clientRESTinfo);

        // add Sign and Light, if assigned, to userLayers
        ['Sign', 'Light'].forEach(childName =>{
          const childAssetClass = {... _this.currentUser.assignedAssetClasses.find(ac => ac.name === childName)}; // get clone! don't want to update the currentUser behaviorsubject
          if (childAssetClass) { 
            childAssetClass.type = "inventoryTable";
            this.layerData.userLayers.push(childAssetClass); }   //10/2/26 add child asset classes to userLayers and discontinue using separate inventoryLayersData and currentUser.assignedAssetClasses
          }
        )

        if (_this.regionData.length > 0) {

          this.assetAttributesService.getTableAlias().subscribe((tblresults: any) => {

            tblresults.features.forEach((element) => {

              // collect feature alias info
              const userLayer = this.layerData.userLayers.find( (lyr: ILayer) => lyr.name === element.attributes.Name);
              if (userLayer) {
                userLayer.alias = element.attributes.Alias;
                userLayer.name = element.attributes.Name;
                userLayer.idPrefix = element.attributes.LayerCode;
                userLayer.aliasSL = element.attributes.Alias_SL;
              }

            });
          });

        } else {
          Swal.fire(this.translateService.instant("Esri-map.alert.noregionmsg"));
        
        }

      },
      (err) => {
        Swal.fire(this.translateService.instant("Esri-map.alert.noregionmsg"));
        this.queryLayersService.getAllLayersInformation(this.currentUser.webServiceURL).subscribe((res) => {
          this.processServiceLayerInformation([], res);
        });
      }
    );

    //Wms layer issue fix data was not displaying on map
    this.GenericLayerService.getVisualizationLayers().subscribe((layerList: any) => {
      var wmsUrlList = layerList.map(function (a) {
        return a.wmsUrl;
      });
      console.log(wmsUrlList);
      wmsUrlList.forEach((wmsUrl) => {
        let domain = new URL(wmsUrl);
        this.wmsUrlHostNames.push(domain.hostname);
      });
    });

    this.GenericLayerService.getuserAPILanguage().subscribe(
      (res: any) => {
        this.langkeyrec = res.languageKey;

        // this.initializeMap().then((mapView) => {});
        this.initializeMap();
      },
      (err) => {
        console.log(err);
      }
    );
    // Initialize MapView and return an instance of MapView
  }

  ngAfterViewInit() {
    // For ADA story - by Subba
    let mainPageTools2 = document.querySelectorAll('[data-BMapTabbing="yes"]');
    if (mainPageTools2.length > 0) {
      mainPageTools2.forEach((element) => {
        element.setAttribute("tabindex", "0");
      });
    }
  }
  //TODO ADD TO A SERVICE
  setEsriHeader(ioArgs) {
    if (ioArgs.url.includes("gisproxy")) {
      // don't forget to return ioArgs.
      ioArgs.headers = { ProxyAuthorization: `Bearer ${this.authenticationService.accessTokenObj.value.accessToken}` };
    }
    return ioArgs;
  }
  async initializeMap() {
    try {
      const _this = this.setThis();
      const options = {
        version: "3.43",
        css: true,
        // insert the stylesheet link above the first <style> tag on the page
        insertCssBefore: "style",
        dojoConfig: {
          locale: this.langkeyrec,
          parseOnLoad: true,
          async: true,
          packages: [
            {
              name: "sms",
              location: location.pathname.replace(/\/[^/]+$/, "") + "assets/esri-widgets/"
            }
          ]
        }
      };
      // loadCss(options.version);
      // Load the modules for the ArcGIS API for JavaScript
      loadModules(
        [
          // esri modules
          "esri/map",
          "esri/graphic",
          "esri/InfoTemplate",
          "esri/units",
          "esri/Color",
          "esri/request",
          "esri/TimeExtent",
          // toolbars
          "esri/toolbars/draw",
          "esri/toolbars/edit",
          // tasks
          "esri/tasks/query",
          "esri/tasks/locator",
          "esri/tasks/RelationshipQuery",
          "esri/tasks/QueryTask",
          "esri/tasks/Geoprocessor",
          // layers
          "esri/layers/FeatureLayer",
          "esri/layers/VectorTileLayer",
          "esri/layers/GraphicsLayer",
          "esri/layers/ArcGISDynamicMapServiceLayer",
          "esri/layers/TimeInfo",
          "esri/layers/WMSLayer", // Added for visualization layers
          // dijit widgets
          "esri/dijit/Measurement",
          "esri/dijit/BasemapGallery",
          "esri/dijit/BasemapToggle",
          "esri/dijit/LocateButton",
          "esri/dijit/OverviewMap",
          "esri/dijit/Search",
          "esri/dijit/ColorPicker",
          ////"esri/dijit/Legend",
          "esri/dijit/Popup",
          "esri/dijit/PopupTemplate",
          "esri/dijit/Scalebar",
          "esri/dijit/AttributeInspector",
          "esri/dijit/FeatureTable",
          "esri/dijit/TimeSlider",
          // geometry
          "esri/geometry/Extent",
          "esri/geometry/Point",
          "esri/geometry/Circle",
          "esri/geometry/webMercatorUtils",
          "esri/geometry/ScreenPoint",
          "esri/geometry/scaleUtils",
          "esri/geometry/Polyline",
          "esri/geometry/Polygon",
          "esri/geometry/mathUtils",
          "esri/geometry/geometryEngine",
          "esri/geometry/jsonUtils",
          // symbols
          "esri/symbols/SimpleLineSymbol",
          "esri/symbols/SimpleFillSymbol",
          "esri/symbols/SimpleMarkerSymbol",
          "esri/symbols/PictureMarkerSymbol",
          "esri/symbols/TextSymbol",
          "esri/symbols/Font",
          // renderers
          "esri/renderers/SimpleRenderer",
          // external widgets
          "sms/multipopup/PopupExtended",
          // dojo
          "dojo/dom-construct",
          "dojo/promise/all",
          // TSDRSAM-1099 Manikantha V
          "dojo/i18n!esri/nls/jsapi",
          "esri/graphicsUtils",
          "dojo/_base/event",
          // dijit
          "dijit/registry",
          "esri/urlUtils",
          "esri/config"
        ],
        options
      )
        .then(
          ([
            Map,
            Graphic,
            InfoTemplate,
            Units,
            Color,
            request,
            TimeExtent,
            Draw,
            Edit,
            Query,
            Locator,
            RelationshipQuery,
            QueryTask,
            Geoprocessor,
            FeatureLayer,
            VectorTileLayer,
            GraphicsLayer,
            ArcGISDynamicMapServiceLayer,
            TimeInfo,
            wmsLayer, // Added for visualization layers
            Measurement,
            BasemapGallery,
            BasemapToggle,
            LocateButton,
            OverviewMap,
            Search,
            ColorPicker,
            ////Legend,
            Popup,
            PopupTemplate,
            Scalebar,
            AttributeInspector,
            FeatureTable,
            TimeSlider,
            Extent,
            Point,
            Circle,
            webMercatorUtils,
            ScreenPoint,
            scaleUtils,
            Polyline,
            Polygon,
            mathUtils,
            geometryEngine,
            geometryJsonUtils,
            SimpleLineSymbol,
            SimpleFillSymbol,
            SimpleMarkerSymbol,
            PictureMarkerSymbol,
            TextSymbol,
            Font,
            SimpleRenderer,
            PopupExtended,
            domConstruct,
            all,
            // TSDRSAM-1099 Manikantha V
            esriBundle,
            graphicsUtils,
            event,
            registry,
            urlUtils,
            esriConfig
          ]) => {
            request.setRequestPreCallback((ioArgs) => this.setEsriHeader(ioArgs));
            const urlPrefix = this.getUrlPrefix(environment.proxy) + "/arcgis/rest";
            const proxyUrl = environment.proxy.slice(0, -1); //e.g. "https://ramuatonline.com/proxy/proxy.ashx"
            const ret = urlUtils.addProxyRule({
              urlPrefix: urlPrefix, // specify resource location
              proxyUrl: proxyUrl // specify location of proxy file
            });
            this.wmsUrlHostNames.forEach((hostName) => {
              esriConfig.defaults.io.corsEnabledServers.push(hostName);
            });
            _this.map = new Map(_this.mapViewEl.nativeElement, {
              center: _this.center,
              zoom: _this.zoom,
              basemap: _this.basemap,
              slider: false,
              showAttribution: false,
              logo: false
            });

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const scalebar = new Scalebar({
              map: _this.map,
              attachTo: "bottom-right",
              // "dual" displays both miles and kilometers
              // "english" is the default, which displays miles
              // use "metric" for kilometers
              scalebarUnit: "dual"
            });
            _this.map.on("load", () => {
              this.mapLoadedEvent.emit(true);
              // set callbacks to class variables
              _this.Draw = Draw;
              _this.Measure = Measurement;
              _this.Query = Query;
              _this.FeatureLayer = FeatureLayer;
              _this.GraphicsLayer = GraphicsLayer;
              _this.ArcGISDynamicMapServiceLayer = ArcGISDynamicMapServiceLayer;
              _this.BasemapGallery = BasemapGallery;
              _this.BasemapToggle = BasemapToggle;
              _this.LocateButton = LocateButton; // Locate
              _this.Extent = Extent; // setExtent
              _this.OverviewMap = OverviewMap; // InsetMap
              _this.SearchWidget = Search; // Search Widget
              _this.InfoTemplate = InfoTemplate; // Info template
              _this.Color = Color;
              _this.SimpleLineSymbol = SimpleLineSymbol;
              _this.SimpleMarkerSymbol = SimpleMarkerSymbol;
              _this.SimpleFillSymbol = SimpleFillSymbol;
              _this.TextSymbol = TextSymbol;
              _this.Font = Font;
              ////_this.Legend = Legend;
              _this.Graphic = Graphic;
              _this.Circle = Circle;
              _this.Units = Units;
              _this.Point = Point;
              _this.Locator = Locator;
              _this.ColorPicker = ColorPicker;
              _this.webMercatorUtils = webMercatorUtils;
              _this.PictureMarkerSymbol = PictureMarkerSymbol;
              _this.PopupTemplate = PopupTemplate;
              _this.Popup = Popup;
              _this.domConstruct = domConstruct;
              _this.registry = registry;
              _this.VectorTileLayer = VectorTileLayer;
              _this.ScreenPoint = ScreenPoint;
              _this.PopupExtended = PopupExtended;
              _this.RelationshipQuery = RelationshipQuery;
              _this.AttributeInspector = AttributeInspector;
              _this.FeatureTable = FeatureTable;
              _this.Edit = Edit;
              _this.scaleUtils = scaleUtils;
              _this.request = request;
              _this.QueryTask = QueryTask;
              _this.Polyline = Polyline;
              _this.Polygon = Polygon;
              _this.all = all;
              _this.SimpleRenderer = SimpleRenderer;
              _this.TimeInfo = TimeInfo;
              _this.TimeSlider = TimeSlider;
              _this.TimeExtent = TimeExtent;
              _this.Geoprocessor = Geoprocessor;
              _this.geometryEngine = geometryEngine;
              _this.mathUtils = mathUtils;
              _this.graphicsUtils = graphicsUtils;
              _this.event = event;
              _this.geometryJsonUtils = geometryJsonUtils;
              // TSDRSAM-1099 Manikantha V
              _this.esriBundle = esriBundle;
              _this.wmsLayer = wmsLayer; // Added for visualization layers
              var isDragging = false;
              var dragExtent = null;

              _this.map.on("pointer-down", function (event) {
                isDragging = true;
                dragExtent = event.mapPoint.clone();
              });

              _this.map.on("pointer-up", function (event) {
                if (isDragging) {
                  var startPoint = dragExtent;
                  var endPoint = event.mapPoint.clone();
                  var extent = {
                    xmin: Math.min(startPoint.x, endPoint.x),
                    ymin: Math.min(startPoint.y, endPoint.y),
                    xmax: Math.max(startPoint.x, endPoint.x),
                    ymax: Math.max(startPoint.y, endPoint.y),
                    spatialReference: _this.map.spatialReference
                  };
                  console.log(extent);
                  isDragging = false;
                  dragExtent = null;
                }
              });

              _this.map.on("update-end", function () {
                //6/30/26 added for accessibility 
                document.querySelectorAll("img[decoding]").forEach((img) => {
                  if (!img.hasAttribute("alt")) {
                    img.setAttribute("alt", "map");
                  }
                });
              });

              _this.initApp();
            });
          }
        )
        .catch((err) => {
          // handle any script or module loading errors
          console.error(err);
        });
    } catch (error) {
      console.log("EsriLoader: ", error);
    }
  }

  initApp() {
    try {
      // Added by Manikantha for JIRA ID:-34
      this.genericMapMethodsService.currentUser = this.currentUser;
      this.genericMapMethodsService.setEsriModules(
        this.map,
        this.Draw,
        this.Measure,
        this.Query,
        this.FeatureLayer,
        this.GraphicsLayer,
        this.ArcGISDynamicMapServiceLayer,
        this.BasemapGallery,
        this.LocateButton,
        this.Extent,
        this.OverviewMap,
        this.SearchWidget,
        this.InfoTemplate,
        this.Color,
        this.SimpleLineSymbol,
        this.SimpleMarkerSymbol,
        this.SimpleFillSymbol,
        this.TextSymbol,
        this.Font,
        ////this.Legend,
        this.Graphic,
        this.Circle,
        this.Units,
        this.Point,
        this.Locator,
        this.ColorPicker,
        this.webMercatorUtils,
        this.PictureMarkerSymbol,
        this.PopupTemplate,
        this.Popup,
        this.domConstruct,
        this.registry,
        this.VectorTileLayer,
        this.ScreenPoint,
        this.PopupExtended,
        this.RelationshipQuery,
        this.AttributeInspector,
        this.FeatureTable,
        this.Edit,
        this.scaleUtils,
        this.request,
        this.QueryTask,
        this.Polyline,
        this.Polygon,
        this.all,
        this.SimpleRenderer,
        this.TimeInfo,
        this.TimeSlider,
        this.TimeExtent,
        this.Geoprocessor,
        this.geometryEngine,
        this.mathUtils,
        this.event,
        this.geometryJsonUtils,
        this.graphicsUtils,
        // TSDRSAM-1099 Manikantha V
        this.esriBundle
      );
      this.initTimeOut();
      this.loadLayers();
      this.initBasemap();
      this.initToolbars();
      this.initMeasureTool();
      this.initSearchToolbar();
      var isDragging = false;
      var dragExtent = null;

      this.map.on("pointer-down", function (event) {
        isDragging = true;
        dragExtent = event.mapPoint.clone();
      });

      this.map.on("pointer-up", function (event) {
        if (isDragging) {
          var startPoint = dragExtent;
          var endPoint = event.mapPoint.clone();
          var extent = {
            xmin: Math.min(startPoint.x, endPoint.x),
            ymin: Math.min(startPoint.y, endPoint.y),
            xmax: Math.max(startPoint.x, endPoint.x),
            ymax: Math.max(startPoint.y, endPoint.y),
            spatialReference: this.map.spatialReference
          };
          console.log(extent);
          isDragging = false;
          dragExtent = null;
        }
      });

      // Apply requestRender() fix for iOS
      if (this.isIOS()) {
        console.log("iOS detected — enabling requestRender() on drag");
        const throttledRender = this.throttle(() => this.map.requestRender(), 100);
        this.map.on("drag", throttledRender);
        //this.map.on("drag", this.throttle(() => this.map.requestRender(), 100));
      }

      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.eeService.setEnableSingleClick(true);
    } catch (error) {
      console.error(error);
    }
  }

  initTimeOut() {
    let idleModelRef: NgbModalRef;
    this.userService.getClient(this.currentUser.clientId)
      .pipe(
        map((client: IClient) => client.setTimeOut ?? environment.SetTimeOut))
      .subscribe((setTimeOut: number) => {
        const secondsBeforelogout = 60;
        const secondsBeforeIdle = setTimeOut - secondsBeforelogout;

        this.idle.setIdle(secondsBeforeIdle); // how long can they be inactive before considered idle, in seconds
        this.idle.setTimeout(secondsBeforelogout); // how long can they be idle before considered timed out, in seconds
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active

        // pop up a warning modal when the user becomes idle
        this.idle.onIdleStart.subscribe(() => {
          if (!this.modalService.hasOpenModals()) {
            idleModelRef = this.modalService.open(IdleModalComponent, {
              centered: true,
              size: "sm",
              backdrop: "static",
              keyboard: false,
              windowClass: "idle-modal"
            });
            // pass in timout to the modal component for countdown
            idleModelRef.componentInstance.secondsBeforelogout = secondsBeforelogout;
          }
        });

        // log out the user when they've been idle too long 
        this.idle.onTimeout.subscribe(() => {
          this.authenticationService.logout(this.currentUser.clientId, this.currentUser.userId)
        });

        this.idle.watch();
      });
  }

  initToolbars() {
    try {
      this.showEsriWidgets = true;
      this.drawTool = new this.Draw(this.map);
    } catch (error) {
      console.error(error);
    }
  }
  initBasemap() {
    try {
      const _this = this.setThis();
      if (!this.basemapGallery) {
        this.basemapGallery = new this.BasemapGallery(
          {
            showArcGISBasemaps: true,
            map: _this.map
          },
          "basemapGalleryDiv"
        );
        this.basemapGallery.startup();
        this.basemapGallery.on("error", function (msg) {
          console.log("basemap gallery error:  ", msg);
        });
        this.basemapToggle = new this.BasemapToggle({ showArcGISBasemaps: true, map: _this.map, basemap: "satellite" }, "BasemapToggleDiv");
        this.basemapToggle.startup();
      }
    } catch (error) {
      console.error(error);
    }
  }

  toggleBasemapGallery() {
    try {
      this.showBaseMapGallery = !this.showBaseMapGallery;
      const slider = document.getElementById("basemaps-more");
      let mainPageTools = document.querySelectorAll('[data-mainPageTabbing="yes"]');
      if (this.showBaseMapGallery) {
        slider.classList.remove("fa-angle-double-left");
        slider.classList.add("fa-angle-double-right");
        //Added for ADA
        mainPageTools.forEach((element) => {
          element.setAttribute("tabindex", "-1");
        });
      } else {
        slider.classList.add("fa-angle-double-left");
        slider.classList.remove("fa-angle-double-right");
        //Added for ADA
        mainPageTools.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  initMeasureTool() {
    try {
      if (!this.measurement) {
        const _this = this.setThis();
        // symbols for measure tool -------------------------------------
        const selectedColor = new this.Color([255, 0, 0, 1]);
        const lineSymbol = new this.SimpleLineSymbol(this.SimpleLineSymbol.STYLE_SOLID, selectedColor, 4);
        const fillSymbol = new this.SimpleFillSymbol(this.SimpleFillSymbol.STYLE_SOLID, lineSymbol, new this.Color([255, 255, 0, 0]));
        this.measurement = new this.Measure(
          {
            map: _this.map,
            fillSymbol,
            lineSymbol
          },
          "measureWidgetDiv"
        );
        this.measurement.startup();
        // creating graphics layer for measure
        _this.measureGlayer = new _this.GraphicsLayer({
          id: "measure-result-glayer"
        });
        _this.map.addLayer(_this.measureGlayer, 100);
        const font = new _this.Font("20pt", _this.Font.STYLE_NORMAL, _this.Font.WEIGHT_BOLD, "Courier");
        this.measurement.on("measure-start", (evt) => {
          const tool = this.measurement.getTool();
          if (tool.toolName === "area") {
            _this.measureGlayer.clear();
          }
        });
        this.measurement.on("measure", (evt) => {
          _this.measureGlayer.clear();
          const textSym = new _this.TextSymbol(evt.values.toFixed(2) + " " + evt.unitName, font);
          _this.measureGlayer.add(new _this.Graphic(evt.geometry, textSym));
          this.measurement.resultValue.srcNodeRef.innerHTML = evt.values.toFixed(2) + " " + evt.unitName;
        });
        this.measurement.on("measure-end", function (evt) {
          // added whole function
          this.measurement.resultValue.srcNodeRef.innerHTML = evt.values.toFixed(2) + " " + evt.unitName;
        });
        this.measurement.on("tool-change", (evt) => {
          _this.measureGlayer.clear();
        });
        //Added for ADA
        let measureTools = document.querySelectorAll("span.dijit.dijitReset.dijitInline.esriButton");
        measureTools.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });
        let measureTools2 = document.querySelectorAll("span.dijit.dijitReset.dijitInline.esriToggleButton");
        measureTools2.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });

        //6/30/26 added for accessibility 
        document.querySelectorAll("#measure img").forEach((img) => {
          img.setAttribute("alt", "coordinates");
        });


      } else {
        this.measurement.clearResult();
        this.measureGlayer.clear();
      }
    } catch (error) {
      console.error(error);
    }
  }
  initSearchToolbar() {
    try {
      const _this = this.setThis();
      if (!this.searchWidget) {
        this.searchWidget = new this.SearchWidget(
          {
            map: _this.map,
            allPlaceholder: "Search",
            sources: []
          },
          "searchWidgetDiv"
        );
        this.searchWidget.startup();

        //6/30/26 added for accessibility. This version of search widgit initializes title w/no value which gets flagged by accessibility evaluation tool.
        setTimeout(() => {
          document.querySelectorAll("#searchWidgetDiv #searchWidgetDiv_input").forEach((input) => {
            if (!input.hasAttribute("title") || input.getAttribute("title") === "") {
              input.setAttribute("title", "Submit Search");
            }
          });
        }, 500);


      } else {
        this.searchWidget.clear();
      }
    } catch (error) {
      console.error(error);
    }
  }

  deactivateMeasure() {
    try {
      if (this.measurement) {
        this.measurement.clearResult();
      }
      if (this.measureGlayer) {
        this.measureGlayer.clear();
      }
      const tool = this.measurement.getTool();
      if (tool) {
        this.measurement.setTool(tool.toolName, false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleMeasure() {
    try {
      this.measurement.clearResult();
      this.measureGlayer.clear();
      this.showMeasure = !this.showMeasure;
      if (this.showMeasure === true) {
        // when measure is visible
        this.showLayers =
          this.showFilter =
          this.showSearch =
          this.showSelect =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showRedlineDraw =
          this.showAdd =
          this.closeQueryBuilderVar =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.measurement.setTool("distance", true);
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(false);
      } else {
        // when measure is not visible
        const tool = this.measurement.getTool();
        if (tool) {
          this.measurement.setTool(tool.toolName, false);
        }
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(true);
      }
      this.showAssetViewer(false);
    } catch (error) {
      console.error(error);
    }
  }

  toggleLayers() {
    try {
      this.showLayers = !this.showLayers;
      //this.showLayerList = !this.showLayers ? this.showLayers : this.showLayerList;
      if (this.showLayers === true) {
        this.showMeasure =
          this.showFilter =
          this.showSearch =
          this.showSelect =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showRedlineDraw =
          this.showAdd =
          this.closeQueryBuilderVar =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.deactivateMeasure();
        this.showAssetViewer(false);
        this.setFocusOnTool("mat-tab-label-0-0");
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleAdministrator() {
    try {
      this.closeAdministrator = !this.closeAdministrator;
      if (this.closeAdministrator === true) {
        this.showLayers = this.showFilter = this.showSearch = this.showSelect = this.showMeasure = this.showAdd = this.showRedlineDraw = this.DataEditor = false;
        this.deactivateMeasure();
        if (this.showSelect) {
          this.selectTools.fnClearSelection();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleQueryBuilder() {
    try {
      this.closeQueryBuilderVar = !this.closeQueryBuilderVar;
      if (this.closeQueryBuilderVar === true) {
        if (this.showSelect) {
          this.selectTools.fnClearSelection();
        }
        this.showLayers =
          this.showFilter =
          this.showSearch =
          this.showSelect =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showMeasure =
          this.showAdd =
          this.assetViewerVisible =
          this.showRedlineDraw =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.isFromQB = true;
        this.eeService.setAssetViewer(false);
        this.deactivateMeasure();

        this.setFocusOnTool("qbLayerDropdown");

      } else {
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(true);
        // Added by Madhuri Gupta for JIRA ID:-62 on 08/11/2021
        this.genericMapMethodsService.queryBuilderZoomExtent = false;
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleHelpCenter() {
    try {
      this.closeHelpVar = !this.closeHelpVar;
      if (this.closeHelpVar === true) {
        if (this.showSelect) {
          this.selectTools.fnClearSelection();
        }
        this.showLayers =
          this.showFilter =
          this.showSearch =
          this.showSelect =
          this.crowdSourceVar =
          this.closeQueryBuilderVar =
          this.showMeasure =
          this.showAdd =
          this.assetViewerVisible =
          this.showRedlineDraw =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.eeService.setAssetViewer(false);
        this.deactivateMeasure();
        this.showAssetViewer(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleCrowdSourced() {
    try {
      this.crowdSourceVar = !this.crowdSourceVar;
      if (this.crowdSourceVar === true) {
        this.showLayers =
          this.showFilter =
          this.showSearch =
          this.showSelect =
          this.closeHelpVar =
          this.closeQueryBuilderVar =
          this.showMeasure =
          this.showAdd =
          this.showRedlineDraw =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.deactivateMeasure();
        this.showAssetViewer(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleCrewManagement() {
    try {
      this.crewmanagement = !this.crewmanagement;
      if (this.crewmanagement === true) {
        this.showLayers =
          this.showFilter =
          this.showSearch =
          this.showSelect =
          this.closeHelpVar =
          this.closeQueryBuilderVar =
          this.showMeasure =
          this.showAdd =
          this.showRedlineDraw =
          this.DataEditor =
          this.crowdSourceVar =
          this.taskTableVisible =
          this.makeViewerVisible =
          false;
        this.deactivateMeasure();
        this.showAssetViewer(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  crowdsource() {
    try {
      this.showSelect = false;
      this.eeService.setAssetViewer(false);
      this.selectTools.fnClearSelection();
      if (this.crowdSource) {
        this.crowdSource.getAllComplaint();
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleRedlineDraw() {
    try {
      this.showSelect = !this.showSelect;
      this.showRedlineDraw = !this.showRedlineDraw;
      if (this.showRedlineDraw === true) {
        this.showLayers =
          this.showFilter =
          this.showSearch =
          this.showSelect =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showMeasure =
          this.showAdd =
          this.closeQueryBuilderVar =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.deactivateMeasure();
        this.showAssetViewer(false);
      } else {
        this.eeService.setEnableSingleClick(true);
      }
    } catch (error) {
      console.error(error);
    }
  }

  setFocusOnTool(elementId: string, delay: number = 0) {
    // added 7/14/26 -- Set focus to appropriate element on active tool, for better user/accessibility experience
    setTimeout(() => {
      const el = document.getElementById(elementId);
      if (el) {
        el.focus();
      }
    }, delay);
  }

  saveQBTableData(event) {
    this.queryBuilderArray = event;
  }
  closeQueryBuilder(event) {
    try {
      const componentType = document.getElementById("querybuilder");
      const hasClass = componentType.classList.contains("i-active");
      if (hasClass) {
        componentType.classList.remove("i-active");
      }
      this.closeQueryBuilderVar = event;
    } catch (error) {
      console.error(error);
    }
  }
  closeHelpCenterBuilder(event) {
    try {
      this.closeHelpVar = event;
    } catch (error) {
      console.error(error);
    }
  }
  closeCrowdSourceBuilder(event) {
    this.crowdSourceVar = event;
  }
  closeCrewManagement(event) {
    this.crewmanagement = event;
  }
  toggleSearch() {
    try {
      this.searchWidget.clear();
      this.showSearch = !this.showSearch;
      if (this.showSearch === true) {
        this.searchTools.showSearchWidget(true);
        this.showLayers = this.showFilter = this.showMeasure = this.showSelect = this.closeHelpVar = this.showRedlineDraw = this.showAdd = this.closeQueryBuilderVar = this.DataEditor = false;
        this.deactivateMeasure();
        this.showAssetViewer(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleFilter() {   //aka toggleRegions
    try {
      this.showFilter = !this.showFilter;
      if (this.showFilter === true) {
        this.showLayers =
          this.showSearch =
          this.showMeasure =
          this.showSelect =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showRedlineDraw =
          this.showAdd =
          this.closeQueryBuilderVar =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.deactivateMeasure();
        this.showAssetViewer(false);

        setTimeout(() => {
          //const container = document.getElementById("makeViewerContainer");
          //const chkboxes = container ? container.querySelectorAll('input[type="checkbox"]') : [];
          const radioBtns = document.querySelectorAll('input[type="radio"]');
          if (radioBtns.length > 0) {
            this.setFocusOnTool(radioBtns[0].id);
          }
        }, 0)

      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleSelect() {
    try {
      if (!this.showSelect) {
        if (this.closeQueryBuilderVar === true && this.selectedSet && this.selectedSet.length > 0) {
          this.isFromQB = false;
        }
        this.showLayers = this.showSearch = this.showMeasure = this.showFilter = this.closeHelpVar = this.showRedlineDraw = this.showAdd = this.closeQueryBuilderVar = this.DataEditor = this.crewmanagement = false;
        this.deactivateMeasure();
        this.setFocusOnTool("Extent");
      } else {
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(true);
      }
      this.showSelect = !this.showSelect;
    } catch (error) {
      console.error(error);
    }
  }
  toggleMaintenanceViewer() {
    try {
      if (!this.taskTableVisible) {
        if (this.showSelect) {
          this.selectTools.fnClearSelection();
        }
        this.showLayers =
          this.showSearch =
          this.showMeasure =
          this.showFilter =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showRedlineDraw =
          this.showAdd =
          this.closeQueryBuilderVar =
          this.showSelect =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.deactivateMeasure();
        this.showAssetViewer(false);
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(false);
      } else {
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(true);
      }
      this.eeService.setMaintenanceView();

      setTimeout(() => {
        const container = document.getElementById("myMaintenanceContainer");
        const chkboxes = container ? container.querySelectorAll('input[type="checkbox"]') : [];
        if (chkboxes.length > 0) {
          this.setFocusOnTool(chkboxes[0].id);
        }
      }, 0)

    } catch (error) {
      console.error(error);
    }
  }
  toggleMakeViewer() {
    try {
      if (!this.makeViewerVisible) {
        if (this.showSelect) {
          this.selectTools.fnClearSelection();
        }
        this.showLayers =
          this.showSearch =
          this.showMeasure =
          this.showFilter =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showRedlineDraw =
          this.showAdd =
          this.closeQueryBuilderVar =
          this.showSelect =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.deactivateMeasure();
        this.showAssetViewer(false);
        this.eeService.setEnableSingleClick(false);
      } else {
        this.eeService.setEnableSingleClick(true);
      }
      this.eeService.setMakeViewer();

      setTimeout(() => {
        const container = document.getElementById("makeViewerContainer");
        const chkboxes = container ? container.querySelectorAll('input[type="checkbox"]') : [];
        if (chkboxes.length > 0) {
          this.setFocusOnTool(chkboxes[0].id);
        }
      }, 0)

    } catch (error) {
      console.error(error);
    }
  }


  toggleAdd() {
    try {
      this.showAdd = !this.showAdd;
      if (this.showAdd === true) {
        if (this.showSelect) {
          this.selectTools.fnClearSelection();
        }
        this.showLayers =
          this.showSearch =
          this.showMeasure =
          this.showFilter =
          this.closeHelpVar =
          this.crowdSourceVar =
          this.showRedlineDraw =
          this.showSelect =
          this.closeQueryBuilderVar =
          this.DataEditor =
          this.crewmanagement =
          false;
        this.isFromQB = false;
        this.deactivateMeasure();
        this.setFocusOnTool("addAssetClass", 500);
      }
    } catch (error) {
      console.error(error);
    }
  }
  createTaskforAsset(event) {
    try {
      this.objGlobals.complaintID = event.ComplaintId;
      this.objGlobals.latitude = event.latitude;
      this.objGlobals.longitude = event.longitude;
      this.toggleSelect();
    } catch (error) {
      console.error(error);
    }
  }
  initLocationButton() {
    try {
      const _this = this.setThis();
      const geoLocate = new this.LocateButton(
        {
          map: _this.map,
          highlightLocation: true
        },
        "locateBtn"
      );
      geoLocate.startup();
    } catch (error) {
      console.error(error);
    }
  }

  loadLayers() {
    try {
      const _this = this.setThis();
      const layersInfo: any = [];
      const layerFilters: any = [];   // esri oddity: setLayerDefinitions takes an array param where index corresponds to layerId
      const visibleLyrs: any = [];
      const regionFilter = this.getRegionFilterExp(this.regionData[0]);

      if (this.layerData.userLayers.length > 0) {

        this.layerData.userLayers.forEach((lyr: ILayer) => {

          // create feature layer object and add to userLayers.lyrObj
          const url = this.currentUser.webServiceURL.trim() + "FeatureServer/" + lyr.layerId;
          const options: any = { 
            mode: _this.FeatureLayer.MODE_ONDEMAND, 
            outFields: ["*"],
            id: lyr.name + lyr.layerId,
            infoTemplate: lyr.name === "GPSTrackLog" ? this.getInfoTemplateForTrackLogLayer() : undefined
          };
          lyr.lyrObj = new _this.FeatureLayer(url, options); // Layer Options Added By Sathish

          // collect layer filters
          if (lyr.type === "inventory") {
            layerFilters[lyr.layerId] = regionFilter;
            lyr.lyrObj.setDefinitionExpression(regionFilter);
          } else if (lyr.name === "GPSTrackLog") {
            layerFilters[lyr.layerId] = "Inspector='" + this.currentUser.username + "'";
          }

          // collect default visible layers
          if (lyr.visible) {
            visibleLyrs.push(lyr.layerId);
          }

          // collect layer alias
          if (lyr.alias == null || lyr.alias === undefined) {
            layersInfo.push({ layer: lyr.lyrObj, title: lyr.name });
          } else { //if (lyr.alias.length > 0) {
            layersInfo.push({ layer: lyr.lyrObj, title: this.currentUser.scndLang ? lyr.aliasSL : lyr.alias });
          }

        });

        // esri rest layer
        this.mapServiceLyr = new this.ArcGISDynamicMapServiceLayer(this.currentUser.webServiceURL.trim() + environment.mapServer, {
          id: "sms-layers"
        });
        this.mapServiceLyr.setLayerDefinitions(layerFilters);
        this.map.addLayer(this.mapServiceLyr);
        this.layerData.dynamicMapLayer = this.mapServiceLyr;

        // graphics layer for selection
        const selectionGraphicsLyr = new this.GraphicsLayer({ id: "sms-selection" });
        this.map.addLayer(selectionGraphicsLyr);
        this.layerData.graphicLayers.push(selectionGraphicsLyr);

         // add legend images to spatial layer collections
        this.GenericLayerService.getLegend(this.mapServiceLyr.url).subscribe((legendJson: any) => {
          const legendInfo = legendJson?.layers.map((l) => {
            return {
              id: l.layerId,
              image: l.legend[0].imageData
            };
          });
          this.layerData.userLayers.forEach((layer) => {
            layer.legendImage = legendInfo.find((l) => l.id === layer.layerId)?.image;
          });
        });


        this.getExtentFromRegion(this.layerData.userLayers.find( (lyr) => lyr.name.includes("Region")).lyrObj);
        this.setVisibleLayers(visibleLyrs);
        this.map.smsLayerdata = this.layerData;
        this.map.smsRegiondata = this.regionData;
        this.getVisualizationLayers();

        this.eeService.setUserLayers(this.layerData.userLayers);

        // //6/30/26 added for accessibility 
        // setTimeout(() => {
        //   document.querySelectorAll("img[decoding]").forEach((img) => {
        //     if (!img.hasAttribute("alt")) {
        //       img.setAttribute("alt", "map");
        //     } 
        //   }); 
        // }, 3500);

      }
    } catch (error) {
      console.error(error);
    }
  }

  getRegionFilterExp(regionObj) {
    try {
      return "Region" + regionObj.regionLevel + "='" + regionObj.regionName + "' AND Status <> 'Inactive'";
    } catch (error) {
      console.error(error);
    }
  }

  toggleMapLayers(event, lyr: ILayer) {
    try {
      lyr.visible = !lyr.visible;
      let visibleLyrs = this.mapServiceLyr.visibleLayers;
      if (lyr.visible && !visibleLyrs.includes(lyr.layerId)) {
        visibleLyrs.push(lyr.layerId);
      }
      else if (!lyr.visible && visibleLyrs.includes(lyr.layerId)) {
        visibleLyrs = visibleLyrs.filter((id) => id !== lyr.layerId);
      }
      this.setVisibleLayers(visibleLyrs);
    } catch (error) {
      console.error(error);
    }
  }

  setVisibleLayers(visibleLyrs) {
    this.mapServiceLyr.setVisibleLayers(visibleLyrs);

    //12/26/25 need visible layer Ids, including child layer Ids, to generate appropriate worker lists need to know which layers are visible
    let signLyrId = this.currentUser.tableIds.signId;
    let lightLyrId = this.currentUser.tableIds.lightId;
    let supportLyrId = this.layerData.userLayers.find(ul => ul.name == "Support").layerId;
    const visibleLyrsPlusChildren = Array.from(visibleLyrs);
    if (visibleLyrsPlusChildren.includes(supportLyrId)) {
      visibleLyrsPlusChildren.push(signLyrId);
      visibleLyrsPlusChildren.push(lightLyrId);
    }
    this.objGlobals.visibleLayerIds = visibleLyrsPlusChildren;
  }

  switchBasemap(type: string) {
    try {
      if (type === "satellite") {
        this.basemapGallery.select(this.satMapId);
      } else if (type === "streets") {
        this.basemapGallery.select(this.streetMapId);
      }
    } catch (error) {
      console.error(error);
    }
  }

  switchTabs(tab) {
    this.layerTabActive = tab === "layers" ? true : false;
    this.visualizationLyrTabActive = tab === "visualizationlayers" ? true : false; // Added for Visualization layers
  }

  invokePopup(type) {
    try {
      if (type === "querybuilder") {
        this.isFromQB = true;
      } else {
        this.isFromQB = false;
      }
      this.map.graphicsLayerIds.forEach(
        function (id) {
          this.map.getLayer(id).clear();
        }.bind(this)
      );
      if (type !== "maintenanceViewer") {
        this.taskTableVisible = false;
        this.eeService.setMaintenanceView(false);
      }
      if (type !== "makeViewer") {
        this.makeViewerVisible = false;
        this.eeService.setMakeViewer(false);
      }
      this.map.graphics.clear();

      if (this.selectedSet.length > 0) {
        // I think selectedSet should already have been cleared by here
        this.selectedSet = [];
      }
      this.closeCardView(true);
      this.eeService.clearActiveAssetVariables();

      const allHeaders = [
        "measure",
        "layers",
        "search",
        "redline",
        "filter",
        "select",
        "user-profile",
        "add",
        "querybuilder",
        "administrator",
        "helpCenter",
        "crowdSource",
        "maintenanceViewer",
        "datacollectorSettings",
        "crewmanagement"
      ];
      allHeaders.forEach((val) => {
        if (val !== type) {
          this.close(null, val);
        }
      });
      if (type === "measure") {
        this.toggleMeasure();
      } else if (type === "basemap") {
        this.toggleBasemapGallery();
      } else if (type === "layers") {
        this.toggleLayers();
      } else if (type === "search") {
        this.toggleSearch();
      } else if (type === "redline") {
        this.toggleRedlineDraw();
      } else if (type === "filter") {  //aka regions
        this.toggleFilter();
      } else if (type === "select") {
        this.toggleSelect();
      } else if (type === "add") {
        this.toggleAdd();
      } else if (type === "querybuilder") {
        this.toggleQueryBuilder();
      } else if (type === "maintenanceViewer") {
        this.toggleMaintenanceViewer();
      } else if (type === "administrator") {       // 'admin' is the string passed in
        this.toggleAdministrator();
      } else if (type === "helpCenter") {
        this.toggleHelpCenter();
      } else if (type === "crowdSource") {
        this.toggleCrowdSourced();
      } else if (type === "datacollectorSettings") {
        this.toggleDataEditor();
      } else if (type === "crewmanagement") {
        this.toggleCrewManagement();
      } else if (type === "makeViewer") {
        this.toggleMakeViewer();
      }
    } catch (error) {
      console.error(error);
    }
  }

  errback(err) {
    console.log("Error :", err);
  }
  displayTaskinViewer(rowObj) {
    // called when row data emitted by Task and Make. However they don't currently emit and Asset Viewer is managed from within the component.
    this.selectedSet = rowObj;  // 20260819 not current called. task viewer management handled in the task-table.component
  }
  ngOnDestroy() {
    // console
  }
  /**
   * Closes the header popup
   * Makes the respective header icon Inactive
   *
   */
  close(event, type) {
    try {
      const componentType = document.getElementById(type);
      if (!componentType) {
        return;
      }
      const hasClass = componentType.classList.contains("i-active");
      if (hasClass) {
        componentType.classList.remove("i-active");
      }
      if (this.showRedlineDraw && type === "redline") {
        if (document.getElementById("more").classList.contains("i-active")) {
          document.getElementById("more").classList.remove("i-active");
        }
        this.showRedlineDraw = false;
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(true);
      }
      if (this.showMeasure && type === "measure") {
        if (document.getElementById("more").classList.contains("i-active")) {
          document.getElementById("more").classList.remove("i-active");
        }
        this.showMeasure = false;
        // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
        this.eeService.setEnableSingleClick(true);
      }
      this.deactivateTools();
    } catch (error) {
      console.error(error);
    }
  }
  deactivateTools() {
    try {
      if (this.drawTool) {
        this.drawTool.deactivate();
        this.map.enableMapNavigation();
      }
      if (this.measurement && this.measurement.getTool()) {
        this.measurement.setTool(this.measurement.getTool().toolName, false);
        this.measurement.clearResult();
        this.measureGlayer.clear();
      }
      if (this.showSearch) {
        this.searchTools.showSearchWidget(false);
      }
    } catch (error) {
      console.error(error);
    }
  }

  processEmittedData(selectedSet: ILayerSelections[]) {
    // selection emitted from Query Builder, Select or Search       where is single-click selection handled?
    if (selectedSet.length === 0) {
      this.selectedSet = [];
    } else {
      this.selectedSet = selectedSet;
    }

    this.eeService.selectedSet = this.selectedSet;
    if (this.selectedSet.length > 0 && this.selectedSet[0].Data.length > 0) {
      this.eeService.setActiveAsset(this.selectedSet[0].Data[0]);
    }
  }

  setRowIndex(event) {
    this.index = event;
  }
  setSelLayerIndex(event) {
    this.layerIndex = event;
  }

  showAssetTable(show: boolean) {
    try {
      this.assetTableVisible = show;
      if (show === false) {
        const btn = document.getElementById("assetTableButton");
        btn?.classList?.remove("i-active");
      }
    } catch (error) {
      console.error(error);
    }
  }
  showTaskData(show: boolean) {
    try {
      this.taskTableVisible = show;
      if (this.taskTableVisible) {
        this.eeService.setMaintenanceView(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  showMakeData(show: boolean) {
    try {
      this.makeViewerVisible = show;
      if (this.makeViewerVisible) {
        this.eeService.setMakeViewer(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  showTaskTable(show: boolean) {
    try {
      this.eeService.setMaintenanceView(show);
    } catch (error) {
      console.error(error);
    }
  }
  //NOTE: don't need showMake from select or query


  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showAssetViewer(show: boolean) {
    try {
      this.eeService.setAssetViewer(show);
    } catch (error) {
      console.error(error);
    }
  }

  closeCardView(show: boolean) {
    try {
      this.eeService.setAssetViewer(false);
      this.close(show, "add");
    } catch (error) {
      console.error(error);
    }
  }

  closeTaskTable(show: boolean) {
    try {
      this.taskTableVisible = this.showSelectedTasksData = this.makeViewerVisible = false;
      this.close(show, "maintenanceViewer");
      this.close(show, "makeViewer");
      this.eeService.setMaintenanceView(false);
      this.eeService.setMakeViewer(false);
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.map.graphics.clear();
      this.selectedSet = [];
      this.closeCardView(true);
      this.eeService.setEnableSingleClick(true);
    } catch (error) {
      console.error(error);
    }
  }
  tasksSelected(event) {
    this.category = event;
  }

  changeRegion(event, reg) {
    try {
      if (reg.regionName) {
        const regionLayer = this.layerData.userLayers.filter((lyr) => lyr.name.includes("Region"));
        this.getExtentFromRegion(regionLayer[0].lyrObj, reg);
        const defExp = this.getRegionFilterExp(reg);
        this.layerData.userLayers.forEach((lyr: ILayer) => {
          if (lyr.type === "inventory") {
            this.mapServiceLyr.layerDefinitions[lyr.layerId] = defExp;
            lyr.lyrObj.setDefinitionExpression(defExp);
          }
        });
      } else {
        Swal.fire(this.translateService.instant("Esri-map.alert.noregiondatamsg"));
      }
    } catch (error) {
      console.error(error);
    }
  }

  getUrlPrefix(inputUrl: string) {
    return inputUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0]; //e.g. "ramuatonline.com" from "https://ramuatonline.com/proxy/proxy.ashx?")
  }

  getExtentFromRegion(regionsFl, region?) {
    const regionObj = region ? region : this.regionData[0];
    const query = new this.Query();
    query.where = "RegionName" + regionObj.regionLevel + "='" + regionObj.regionName + "'";
    regionsFl.selectFeatures(
      query,
      null,
      (evt) => {
        if (evt.length > 0) {
          let poly;
          const geometries = [];
          const regionOverlaps = { "level1": [], "level2": [], "level3": [], "level4": [] }; // every region a user could be assigned to to have access to current asset
          evt.forEach((regionPoly) => {
            geometries.push(regionPoly.geometry);
            if (regionPoly.attributes.RegionName1 && !regionOverlaps.level1.includes(regionPoly.attributes.RegionName1)) {
              regionOverlaps.level1.push(regionPoly.attributes.RegionName1);
            }
            if (regionPoly.attributes.RegionName2 && !regionOverlaps.level2.includes(regionPoly.attributes.RegionName2)) {
              regionOverlaps.level2.push(regionPoly.attributes.RegionName2);
            }
            if (regionPoly.attributes.RegionName3 && !regionOverlaps.level3.includes(regionPoly.attributes.RegionName3)) {
              regionOverlaps.level3.push(regionPoly.attributes.RegionName3);
            }
            if (regionPoly.attributes.RegionName4 && !regionOverlaps.level4.includes(regionPoly.attributes.RegionName4)) {
              regionOverlaps.level4.push(regionPoly.attributes.RegionName4);
            }
          });
          poly = this.geometryEngine.union(geometries);
          this.map.setExtent(poly.getExtent(), true);
          regionObj.Extent = poly.getExtent();
          regionObj.geom = poly;
          this.objGlobals.regionOverlaps = regionOverlaps;
          this.currentUser.selectedRegion = regionObj;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  processServiceLayerInformation(assignedAssetClasses, clientRESTinfo) {
    // assignedAssetClasses = (spatial and non-spatial) inventory layers, with privilege, assigned to the current user's account.
    // clientRESTinfo = info returned by WMS REST endpoint published for the client that current user belongs to.
    // notes: esri WMS provides access to spatial data (layers) and non-spatial data (tables).
    //        rsam client wms are published with spatial data grouped by inventory, tracks, or context.

    try {
        const tableIds: any = {};
        const otherLayerIds: any = {};
        const { groupLayers, spatialLayers } = clientRESTinfo.layers.reduce((acc, lyr) => {
          if (lyr.type === "Group Layer") {
            acc.groupLayers.push(lyr);
          } else {
            acc.spatialLayers.push(lyr);
          }
          return acc;
        }, { groupLayers: [], spatialLayers: [] });
        const inventoryGroupId: number = groupLayers.find(g => g.name.toLowerCase() === "inventory")?.id;
        let privilege: string;
        let groupName: string;
        let layer: ILayer;

        spatialLayers.forEach((lyr) => {

          if (lyr.parentLayerId === inventoryGroupId) {
            privilege = assignedAssetClasses.find( (ac) => ac.layerId === lyr.id )?.accessPrivilege;
            if (privilege === undefined) {
              return; // ignore inventory layers not assigned to the current user
            }
          } else {
            privilege = "Read Only";
          }

          groupName = groupLayers.find(g => g.id === lyr.parentLayerId)?.name.toLowerCase();

          layer = {
            layerId: lyr.id,
            accessPrivilege: privilege,
            name: lyr.name,
            type: groupName,
            visible: !['GPSTrackLog', 'Roads', 'ProjectRoads'].includes(lyr.name)
          } as ILayer;

          if (groupName ==="inventory"){
            this.inventoryLayersData.push(layer);
          } else {
            otherLayerIds[lyr.name] = lyr.id;
            this.referenceLayersData.push(layer);
          }

          this.layerData.userLayers.push(layer);

        });

        clientRESTinfo.tables.forEach((lyr) => {
          switch (lyr.name) {
            case "TableAliases":
              tableIds.tableAliasId = lyr.id;
              break;
            case "FieldAliases":
              tableIds.fieldAliasId = lyr.id;
              break;
            case "InventoryDeletes":
              tableIds.inventoryDeleteId = lyr.id;
              break;
            case "Maintenance":
              tableIds.maintenanceId = lyr.id;
              break;
            case "Assessment":
              tableIds.assessmentId = lyr.id;
              break;
            case "Activity":
              tableIds.activityId = lyr.id;
              break;
            case "Photo":
              tableIds.photoId = lyr.id;
              break;
            case "Light":
              tableIds.lightId = lyr.id;
              break;
            case "AssetCodeDefaults":
              tableIds.assetCodeDefaultsId = lyr.id;
              break;
            case "Sign":
              tableIds.signId = lyr.id;
              break;
            case "Documents":
              tableIds.documentId = lyr.id;
              break;
            case "UserQueryActions":
              tableIds.userQueryActionsId = lyr.id;
              break;
            case "ELife_BaseLife_Config":
              tableIds.baseLifeConfigId = lyr.id;
              break;
            case "ELife_BaseLife_Values":
              tableIds.baseLifeValuesId = lyr.id;
              break;
            case "ELife_Modifier_Config":
              tableIds.modifierConfigId = lyr.id;
              break;
            case "ELife_Modifier_Values":
              tableIds.modifierValueId = lyr.id;
              break;
            case "ActivityDuration":
              tableIds.activityDurationId = lyr.id;
              break;
            case "ActivityToolkit":
              tableIds.activityToolkitId = lyr.id;
              break;
            case "Fields_NonEditable_ByUser":
              tableIds.fieldsNonEditableByUserId = lyr.id;
              break;
            // Added by Sowjanya for JIRA ID:-27  JIRA ID:-29 on 08/17/2021
            case "MaintenanceConfiguration":
              tableIds.maintenanceConfigId = lyr.id;
              break;
          }
        });

        // to do:  rename  this.layerData.userLayers to .userAssetClasses

        this.currentUser.tableIds = tableIds;
        this.currentUser.otherLayerIds = otherLayerIds;
        this.authenticationService.currentUserSubject.next(this.currentUser);

    } catch (error) {
      console.error(error);
      Swal.fire("Map load error. Please refresh the page.");
    }
  }

  getInfoTemplateForTrackLogLayer() {
    try {
      const infoTemplate = new this.InfoTemplate();
      infoTemplate.setTitle("Track Log Info");
      // JIRA ID:-54
      infoTemplate.setContent(
        "<b>Weather Conditions : </b>${WeatherCondition}<br/>" +
        "<b>Start Time: </b>${StartTime}<br/><br/>" +
        "<b>Comments: </b>${Comment}<br/>" +
        "<b>Vehicle Model: </b>${VehicleModel}<br/>" +
        "<b>End Time: </b>${EndTime}<br/>" +
        "<b>Vehicle Year: </b>${VehicleYear}<br/>" +
        "<b>Method: </b>${Method}<br/>" +
        "<b>Inspector: </b>${Inspector}</br>" +
        "<b>Total reported points:</b>${TotalPointsCollected}</br>" +
        "<b>Total discarded points:</b>${TotalPointsDiscarded}</br>" +
        "<b>System crashes:</b>${TotalSystemCrashes}"
      );
      return infoTemplate;
    } catch (error) {
      console.error(error);
    }
  }
  closeTimeSlider() {
    try {
      const component = this.registry.byId("timeSliderWidget");
      if (component) {
        component.destroy();
      }
      document.getElementById("timeSliderHeaderLabels").innerText = "";
      document.getElementById("timeSliderDiv").style.display = "none";
      const featureLayerGPS = this.eeService.userLayers.filter((obj) => obj.name === "GPSTrackLog")[0].lyrObj;
      this.map.removeLayer(featureLayerGPS);
      this.map.infoWindow.hide();
      //Enable single click for asset selection
      this.eeService.setEnableSingleClick(true);
    } catch (error) {
      console.error(error);
    }
  }

  capturescreen() {
    try {
      this.loading = true;
      const config = {
        useCORS: true,
        logging: false,
        allowTaint: true
      };
      html2canvas(this.mapViewEl.nativeElement, config).then((canvas) => {
        const image = canvas.toDataURL("image/jpg").replace("tmage/jpg", "image/octet-stream");
        this.loading = false;

        this.chkimage = image;
        Swal.fire({
          title: this.translateService.instant("Esri-map.alert.screencaptured"),
          imageUrl: image,
          imageWidth: 500,
          imageHeight: 200,
          imageAlt: "Custom image",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.translateService.instant("Esri-map.alert.screensave"),
          showLoaderOnConfirm: true,
          cancelButtonAriaLabel: "Cancel",
          showCloseButton: true,
          customClass: {
            header: "header-swal-override",
            cancelButton: "cancel-button-class",
            closeButton: "close-button-class"
          },
          preConfirm: () => {
            const link = document.createElement("a");
            link.download = "image.jpg";

            const uri = canvas.toBlob(function (blob) {
              link.href = URL.createObjectURL(blob);
              link.click();
            }, "image/png");
          },
          inputAttributes: {
            "aria-label": "control not in use"
          }
        });
      });
    } catch (error) {
      console.error(error);
    }
  }
  closeDataCollector() {
    try {
      this.DataEditor = false;
      if (document.getElementById("more").classList.contains("i-active")) {
        document.getElementById("more").classList.remove("i-active");
      }
    } catch (error) {
      console.error(error);
    }
  }
  toggleDataEditor() {
    try {
      this.dataEditorSettings = JSON.parse(localStorage.getItem("dataEditorSettings"));
      if (this.dataEditorSettings && Object.prototype.hasOwnProperty.call(this.dataEditorSettings, "hardDelete")) {
        this.DataEditor = !this.DataEditor;
        if (this.DataEditor === true) {
          this.showLayers = this.showFilter = this.showSearch = this.showSelect = this.closeQueryBuilderVar = this.closeHelpVar = this.showMeasure = this.showAdd = this.showRedlineDraw = false;
          this.deactivateMeasure();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  choose(target) {
    try {
      if (target.id === "New") {
        this.taskType = "New";
        if (document.getElementById("add_span")) {
          document.getElementById("add_span").className = "icon icon-edit medium";
        }
      } else {
        this.taskType = "Collect";
        if (document.getElementById("add_span")) {
          document.getElementById("add_span").className = "icon addNew-orange medium";
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  saveDataEditor() {
    try {
      if (this.taskType) {
        this.dataEditorSettings.taskType = this.taskType;
      }
      const inthardDel = this.dataEditorSettings.hardDelete ? 1 : 0;
      const isOpenCreateEditTaskForm = this.dataEditorSettings.IsOpenCreateEditTaskForm ? 1 : 0;
      const dataEditorSettings = { hardDelete: inthardDel, IsOpenCreateEditTaskForm: isOpenCreateEditTaskForm };
      localStorage.setItem("dataEditorSettings", JSON.stringify(this.dataEditorSettings));
      this.GenericLayerService.postHardDelete(this.currentUser.clientId, dataEditorSettings).subscribe((res: any) => {
        console.log(res);
      });
      this.closeDataCollector();
    } catch (error) {
      console.error(error);
    }
  }
  deleteType() {
    console.log(this.dataEditorSettings);
    localStorage.setItem("dataEditorSettings", JSON.stringify(this.dataEditorSettings));
  }
  closeFromQB(event) {
    this.isFromQB = event;
  }
  //added by sowjanya JIRA ID-53 15-10-2021
  ExportShapefile() {
    try {
      if (this.Geoprocessor) {
        this.gpServiceTrackUrl = new this.Geoprocessor(environment.gpService);
      }
      if (this.objGlobals.gpstracklogData["startDate"] > this.objGlobals.gpstracklogData["endDate"]) {
        Swal.fire("Esri-map.alert.dateentryvalidate");
      } else if (this.currentUser.clientId === undefined) {
        Swal.fire(this.translateService.instant("Esri-map.alert.clientIDvalidate"));
      } else {
        console.log(this.objGlobals.gpstracklogData);
        const params = {
          // eslint-disable-next-line camelcase
          in_clientID: this.currentUser.clientId,
          // eslint-disable-next-line camelcase
          in_region: "Region",
          // eslint-disable-next-line camelcase
          in_layerName: "GPSTrackLog",
          // eslint-disable-next-line camelcase
          user_id: this.objGlobals.gpstracklogData["selectedUser"],
          // eslint-disable-next-line camelcase
          start_time: this.datepipe.transform(this.objGlobals.gpstracklogData["startDate"], "MM/dd/yyyy"),
          // eslint-disable-next-line camelcase
          end_time: this.datepipe.transform(this.objGlobals.gpstracklogData["endDate"], "MM/dd/yyyy")
        };
        //Eslint camcase confirm - Mani
        this.gpServiceTrackUrl.submitJob(params, this.gpJobComplete.bind(this), this.gpJobStatus.bind(this), this.gpJobFailed.bind(this));
      }
    } catch (error) {
      console.error(error);
    }
  }
  gpJobComplete(jobinfo) {
    try {
      const URLData = environment.gpService + "/jobs/" + jobinfo.jobId + "/results/outputPath";
      this.GenericLayerService.getServiceInfo(URLData).subscribe(
        (urlData: any) => {
          const OpenURL = urlData.value;
          window.open(OpenURL);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
  gpJobStatus(jobinfo) {
    try {
      switch (jobinfo.jobStatus) {
        case "esriJobSubmitted":
          this.ExportStatus = this.translateService.instant("Esri-map.alert.statussubmitted");
          this.loading = true;
          break;
        case "esriJobExecuting":
          this.ExportStatus = this.translateService.instant("Esri-map.alert.statusprocessing");
          this.loading = true;
          break;
        case "esriJobSucceeded":
          this.ExportStatus = this.translateService.instant("Esri-map.alert.chkdownloadfldr");
          this.loading = false;
          break;
      }
    } catch (error) {
      console.error(error);
    }
  }
  gpJobFailed(error) {
    Swal.fire(error);
  }
  //Added for Visualization layers
  //Added by Venkatesh for jira-677,678
  async getVisualizationLayers() {
    await this.GenericLayerService.getVisualizationLayers().subscribe((visualizationLayers: any) => {
      console.log(visualizationLayers);
      visualizationLayers.sort(function (a, b) {
        return a.layerOrder - b.layerOrder;
      });
      visualizationLayers.forEach((visLayer) => {
        visLayer.legend = visLayer.wmsUrl + "?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=15&HEIGHT=15&LAYER=" + visLayer.originalLayerName;
        visLayer.visible = false;
        visLayer.imgLogo = BASE64_PREFIX + visLayer.logo;
        this.visualizationLayersData.push(visLayer);
        var currentLayer = new this.wmsLayer(visLayer.wmsUrl, {
          format: "png",
          visibleLayers: [visLayer.originalLayerName]
        });
        currentLayer.id = visLayer.layerName;
        this.map.addLayer(currentLayer);
        currentLayer.setVisibility(false);
      });
      this.map.visualizationLayers = this.visualizationLayersData;
    });
  }

  toggleVisualizationLayers(visLayer) {
    try {
      visLayer.visible = !visLayer.visible;
      if (visLayer.visible) {
        this.map.getLayer(visLayer.layerName).setVisibility(true);
      } else {
        this.map.getLayer(visLayer.layerName).setVisibility(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  //





  // Simple iOS detection
  isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  // Throttle helper to avoid excessive calls
  throttle(fn, limit) {
    let waiting = false;
    return function () {
      if (!waiting) {
        fn.apply(this, arguments);
        waiting = true;
        setTimeout(() => waiting = false, limit);
      }
    };
  }


}

// added for iOS check
declare global {
  interface Window {
    MSStream: any;
  }
}
